import { DefaultLight } from 'survey-core/themes'

const pmpSurveyTheme = {
  ...DefaultLight,
  themeName: 'pmp',
  cssVariables: {
    ...DefaultLight.cssVariables,
    '--sjs-primary-backcolor': 'rgba(253, 209, 6, 1)',
    '--sjs-primary-backcolor-dark': 'rgba(232, 192, 5, 1)',
    '--sjs-primary-backcolor-light': 'rgba(253, 209, 6, 0.1)',
    '--sjs-primary-forecolor': 'rgba(0, 0, 0, 1)',
    '--sjs-primary-forecolor-light': 'rgba(0, 0, 0, 0.25)',
    '--sjs-editorpanel-backcolor': 'rgba(253, 209, 6, 0.12)',
    // Input border: outer ring layer appended to --sjs-shadow-inner (inputs use box-shadow, not border)
    '--sjs-shadow-inner': 'inset 0px 1px 2px 0px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.35)',
    // Keep the survey title black — without this it falls back to --sjs-primary-backcolor (yellow)
    '--sjs-font-surveytitle-color': 'rgba(0, 0, 0, 0.91)',
  } as Record<string, string>,
}

export default pmpSurveyTheme
